import EntityBase from '@/data/EntityBase';
import IndexedMap from '@/data/IndexedMap';
import { DocumentsModel } from '@/data/documents/models/DocumentsModel';

export type Documents = DocumentState['items'];

export default class DocumentState extends EntityBase({
  items: new IndexedMap(DocumentsModel, 'id', []),
}) {}
